import React from 'react';
import ErrorMessage from '../Elements/ErrorMessage.js';
import SearchParams from '../Elements/SearchParams';
import ServiceSearchParams from '../Contents/Sales/ServiceAdmin/ServiceSearchParams';
import AuthService from './authService.js';
import ServiceFromItem from '../Domain/ServiceFromItem.js';

export default class ServiceService extends React.Component {
  static async GetServiceList(serviceId, clientId, opportunityId) {
    const authService = AuthService.getInstance();

    let url = '/api/Service';

    if (parseInt(serviceId) > 1) {
      url += `/${serviceId}`;
    } else {
      if (clientId != null && clientId !== -1) {
        url += `?clientId=${clientId}`;
      }

      if (opportunityId != null && opportunityId !== -1) {
        url += `${url.includes('?') ? '&' : '?'}opportunityId=${opportunityId}`;
      }
    }
    url += `${url.includes('?') ? '&' : '?'}clearCache=false`;

    return authService.CallBackendFunction(url);
  }

  static async GetServiceListByOpportunityIds(opportunityIds) {
    const authService = AuthService.getInstance();

    const url = '/api/Service/GetServicesByOpportunityIds';

    const data = JSON.stringify(opportunityIds);
    return authService.CallBackendFunctionPost(url, data);
  }

  static async GetServiceListByClientId(clientId) {
    const authService = AuthService.getInstance();

    const url = `/api/Service/GetServicesByClientId${parseInt(clientId) > 1 ? `/${clientId}` : '/0'}`;

    return authService.CallBackendFunction(url);
  }

  static async GetRelatedIncludedServicesByOpportunityId(opportunityId) {
    const url = `/api/Service/GetRelatedIncludedServicesByOpportunityId/${opportunityId}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetServiceListByClientIds(clientIds) {
    const authService = AuthService.getInstance();
    const url = '/api/Service/GetServicesByClientIds';
    const data = JSON.stringify(clientIds);
    return authService.CallBackendFunctionPost(url, data);
  }

  static async GetOpportunityServiceActualData(opportunityId) {
    const url = `/api/Service/GetOpportunityServiceActualData/${opportunityId}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetServiceFromList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ServiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/Service/GetAllServiceListAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertServiceFromDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ServiceFromItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
